var map = {
	"./China.png": "5ead",
	"./Egypt.png": "b43c",
	"./India.png": "a401",
	"./Jordan.png": "904a",
	"./KingdomOfSaudiArabia.png": "4a3e",
	"./Pakistan.png": "9671",
	"./Philippines.png": "e4c6",
	"./Qatar.png": "d983",
	"./Russia.png": "cc57",
	"./Turkey.png": "c37b",
	"./UnitedArabEmirates.png": "96b6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "96ab";